<template>
  <div
    class="modal fade"
    id="addToTampalanModal"
    data-backdrop="static"
    data-keyboard="false"
    tabindex="-1"
    role="dialog"
    aria-labelledby="addToTampalanModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content" v-if="show">
        <div class="modal-header shadow-sm border-outline-dark-bottom">
          <h6 class="modal-title font-weight-bold" id="addToTampalanModalLabel">
            <p class="mb-1">Add Case to Pathcing</p>
          </h6>
          <button
            type="button"
            class="close"
            aria-label="Close"
            @click="closeModal()"
            data-placement="top"
            @mouseover="helper.showTooltip"
            @mouseleave="helper.hideTooltip"
            title="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row mx-0">
            <div class="col">
              <div class="form-group">
                <label class="small">
                  Serial No.<sup class="text-danger">*</sup>
                </label>
                <input
                  type="text"
                  class="form-control form-control-default form-control-sm bg-dark-input"
                  id="SerialNo"
                  placeholder="Enter serial no."
                  v-model="models.serialNo"
                  data-placement="top"
                  @mouseover="helper.showTooltip"
                  @mouseleave="helper.hideTooltip"
                  title="Insert serial no."
                />
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label class="small" for="timestamp">
                  Date<sup class="text-danger">*</sup>
                </label>
                <button
                  class="btn btn-sm btn-light w-100 d-flex justify-content-between align-items-center"
                  @click="showCloseDateSelector = true"
                  data-placement="top"
                  @mouseover="helper.showTooltip"
                  @mouseleave="helper.hideTooltip"
                  title="Click to select date"
                >
                  <span>
                    {{ formatDate(models.timestamp) || "Click to select date" }}
                  </span>
                  <font-awesome-icon :icon="['far', 'calendar-alt']" />
                </button>
              </div>
            </div>
          </div>
          <div class="row m-0">
            <div class="col">
              <div class="form-group">
                <label class="small" for="TypeOfDefect">
                  Type of Defect<sup class="text-danger">*</sup>
                </label>
                <input
                  type="text"
                  step="any"
                  min="0"
                  class="form-control form-control-default form-control-sm bg-dark-input"
                  id="TypeOfDefect"
                  placeholder="Enter type of defect"
                  v-model="models.caption"
                  data-placement="top"
                  @mouseover="helper.showTooltip"
                  @mouseleave="helper.hideTooltip"
                  title="Insert type of defect"
                />
              </div>
            </div>
          </div>
          <!-- <div class="row mx-0">
            <div class="col">
              <div class="form-group">
                <div class="d-flex justify-content-between align-items-center">
                  <label class="small ">
                    District<sup class="text-danger">*</sup>
                  </label>
                </div>
                <div class="dropdown rounded w-100">
                  <button
                    class="btn btn-sm border btn-block dropdown-toggle position-relative d-flex justify-content-between align-items-center px-3 bg-dark-input  border-outline-dark"
                    style="font-size: 0.875rem; color: #495057"
                    type="button"
                    id="dropdownDistrictButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span
                      v-if="
                        districts.find(
                          (district) => models.district == district.id
                        )
                      "
                    >
                      {{
                        districts.find(
                          (district) => district.id == models.district
                        ).name
                      }}
                    </span>
                    <span v-else class="text-muted"> -- Select district </span>
                  </button>
                  <div
                    class="dropdown-menu py-0 w-100 shadow-sm  p-0"
                    aria-labelledby="dropdownDistrictButton"
                    style="height: 200px; overflow: hidden; font-size: 0.875rem"
                  >
                    <input
                      class="form-control form-control-sm  border-outline-dark-bottom "
                      placeholder="Search"
                      v-model="districtSearchModel"
                    />
                    <div style="height: calc(100% - 43px); overflow-y: auto">
                      <button
                        v-for="district in computedDistricts"
                        :key="`select-district-${district.id}`"
                        class="border-bottom dropdown-item px-3 py-2  border-outline-dark "
                        :class="{
                          'bg-subtle': models.district == district.id,
                        }"
                        style="color: #495057"
                        @click="models.district = district.id"
                      >
                        {{ district.name }}
                        <font-awesome-icon
                          :icon="['fas', 'check']"
                          class="text-primary ml-2 small"
                          v-if="models.district == district.id"
                        />
                      </button>
                      <div
                        class="dropdown-item py-2 small text-center text-muted font-italic  px-3 py-2 fs-8"
                      >
                        <span v-if="computedDistricts.length > 0">
                          End of list
                        </span>
                        <span v-else>No district found</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <div class="row mx-0">
            <div class="col">
              <div class="form-group">
                <div class="d-flex justify-content-between align-items-center">
                  <label class="small text-dark">
                    Road<sup class="text-danger">*</sup>
                  </label>
                </div>
                <div class="dropdown rounded w-100">
                  <button
                    class="btn btn-sm border btn-block dropdown-toggle position-relative d-flex justify-content-between align-items-center px-3 bg-dark-input border-outline-dark"
                    style="font-size: 0.875rem; color: #495057"
                    type="button"
                    id="dropdownRoadButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    data-placement="top"
                    @mouseover="helper.showTooltip"
                    @mouseleave="helper.hideTooltip"
                    title="Select road"
                  >
                    <!-- :disabled="!models.district" -->
                    <span
                      v-if="
                        roads.find((road) => road.id == models.pavement_road)
                      "
                    >
                      {{
                        roads.find((road) => road.id == models.pavement_road)
                          .attributes.name
                      }}
                      ({{
                        roads.find((road) => road.id == models.pavement_road)
                          .attributes.owner
                      }})
                    </span>
                    <span v-else class="text-muted"> -- Select road </span>
                  </button>
                  <div
                    class="dropdown-menu py-0 w-100 shadow-sm p-0"
                    aria-labelledby="dropdownRoadButton"
                    style="height: 200px; overflow: hidden; font-size: 0.875rem"
                  >
                    <input
                      class="form-control form-control-sm border-outline-dark-bottom"
                      placeholder="Search"
                      v-model="roadSearchModel"
                      data-placement="top"
                      @mouseover="helper.showTooltip"
                      @mouseleave="helper.hideTooltip"
                      title="Search road"
                    />
                    <div style="height: calc(100% - 43px); overflow-y: auto">
                      <button
                        v-for="road in computedRoads"
                        :key="road.id"
                        class="border-bottom dropdown-item d-flex justify-content-between align-items-center px-3 py-2 border-outline-dark"
                        :class="{
                          'bg-subtle': models.pavement_road == road.id,
                        }"
                        style="color: #495057"
                        @click="models.pavement_road = road.id"
                      >
                        {{ road.attributes.name }} ({{ road.attributes.owner }})
                        <font-awesome-icon
                          :icon="['fas', 'check']"
                          class="text-primary ml-2 small"
                          v-if="models.pavement_road == road.id"
                        />
                      </button>
                      <div
                        class="dropdown-item py-2 small text-center text-muted font-italic px-3 py-2 fs-8"
                      >
                        <span v-if="computedRoads.length > 0">
                          End of list
                        </span>
                        <span v-else>No road found</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mx-0">
            <div class="col">
              <div class="form-group">
                <label class="small" for="Coordinate"> Coordinate </label>
                <div class="row px-1">
                  <div class="col px-2">
                    <input
                      type="text"
                      step="any"
                      min="0"
                      class="form-control form-control-default form-control-sm bg-dark-input"
                      id="lat"
                      placeholder="Enter latitude"
                      v-model="models.lat"
                      data-placement="top"
                      @mouseover="helper.showTooltip"
                      @mouseleave="helper.hideTooltip"
                      title="Insert latitude"
                    />
                  </div>
                  <div class="col px-2">
                    <input
                      type="text"
                      step="any"
                      min="0"
                      class="form-control form-control-default form-control-sm bg-dark-input"
                      id="lng"
                      placeholder="Enter longitude"
                      v-model="models.lng"
                      data-placement="top"
                      @mouseover="helper.showTooltip"
                      @mouseleave="helper.hideTooltip"
                      title="Insert longitude"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer shadow border-outline-dark-top">
          <button
            type="button"
            class="btn btn-link btn-sm"
            @click="closeModal()"
            data-placement="top"
            @mouseover="helper.showTooltip"
            @mouseleave="helper.hideTooltip"
            title="Click to cancel"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-sm btn-primary"
            @click="saveChanges()"
            :disabled="isProcessing"
            data-placement="top"
            @mouseover="helper.showTooltip"
            @mouseleave="helper.hideTooltip"
            title="Click to save"
          >
            <div
              class="spinner-border spinner-border-sm"
              v-if="isProcessing"
            ></div>
            <span v-else>Save</span>
          </button>
        </div>
      </div>
    </div>

    <date-selector
      v-if="showCloseDateSelector"
      :isRange="false"
      @close="closeDateSelected"
    />

    <spinner v-if="isProcessing" />
  </div>
</template>

<script>
import $ from "jquery";
import API from "@/api";
import Helper from "@/helper";
import Spinner from "@/components/Spinner";
import MediaPreview from "@/components/MediaPreview";
import DateSelector from "@/components/DateSelector";
import Swal from "sweetalert2";

export default {
  name: "add-to-tampalan-modal",
  props: ["show"],
  components: { Spinner, MediaPreview, DateSelector },
  data() {
    return {
      helper: Helper,
      isProcessing: false,
      showCloseDateSelector: false,
      districts: [],
      roads: [],
      districtSearchModel: null,
      roadSearchModel: null,
      models: {
        serialNo: null,
        district: null,
        pavement_road: null,
        caption: null,
        timestamp: null,
        lat: null,
        lng: null,
      },
      emptyModels: {
        serialNo: null,
        district: null,
        pavement_road: null,
        caption: null,
        timestamp: null,
        lat: null,
        lng: null,
      },
    };
  },
  watch: {
    show: {
      async handler() {
        if (this.show) {
          $("#addToTampalanModal").modal("show");

          this.models = JSON.parse(JSON.stringify(this.emptyModels));

          await this.getDistricts();
          await this.getIraaRoads();
        } else {
          this.districts = [];

          this.roads = [];

          $("#addToTampalanModal").modal("hide");
        }
      },
      immediate: true,
    },
    "models.district": {
      async handler() {
        if (this.models.district) {
          this.models.pavement_road = null;

          await this.getRoads();
        }
      },
      immediate: true,
      deep: true,
    },
    // "models.pavement_road": {
    //   async handler() {
    //     if (this.models.pavement_road) {
    //       const jalan = this.roads.find(
    //         (r) => r.id == this.models.pavement_road
    //       );

    //       if (jalan) {
    //         const _srArray = jalan.name.split(" ");

    //         if (["jalan", "jln", "j"].includes(_srArray[0].toLowerCase())) {
    //           _srArray.shift();
    //         }

    //         const _jalan = _srArray.join(" ");

    //         const resJalan = await API.get("roads?name_contains=" + _jalan);
    //       }
    //     }
    //   },
    //   immediate: true,
    //   deep: true,
    // },
  },
  computed: {
    computedDistricts() {
      let list = JSON.parse(JSON.stringify(this.districts));

      if (this.districtSearchModel) {
        list = list.filter((l) =>
          l.name.toLowerCase().includes(this.districtSearchModel.toLowerCase())
        );
      }

      return list;
    },
    computedRoads() {
      let list = JSON.parse(JSON.stringify(this.roads));

      if (this.roadSearchModel) {
        list = list.filter(
          (l) =>
            l.attributes.name
              .toLowerCase()
              .includes(this.roadSearchModel.toLowerCase()) ||
            l.attributes.owner
              .toLowerCase()
              .includes(this.roadSearchModel.toLowerCase())
        );
      }

      return list;
    },
  },
  methods: {
    closeDateSelected(e) {
      this.showCloseDateSelector = false;

      if (e) {
        this.models.timestamp = e;
      }
    },
    async getDistricts() {
      this.isProcessing = true;

      return API.get("districts?name_nin=Test District&name_nin=MPKJ")
        .then((retVal) => {
          this.districts = retVal.data;

          this.isProcessing = false;
        })
        .catch((err) => {
          this.isProcessing = false;
        });
    },
    async getRoads() {
      this.isProcessing = true;

      return API.get(`pavement-roads?district=${this.models.district}`)
        .then((retVal) => {
          this.roads = retVal.data;

          this.isProcessing = false;
        })
        .catch((err) => {
          this.isProcessing = false;
        });
    },
    async getIraaRoads() {
      this.isProcessing = true;

      return API.getFromIraa(
        `roads?filters[isTurapanMega]=true&sort[0]=owner&pagination[limit]=200`
      )
        .then((retVal) => {
          // console.log(retVal);
          this.roads = retVal.data.data;

          this.isProcessing = false;
        })
        .catch((err) => {
          this.isProcessing = false;
        });
    },
    formatDate(timestamp) {
      return Helper.formatDate(timestamp, true);
    },
    closeModal(response) {
      if (!this.isProcessing) {
        this.$emit("close", response);
      }
    },
    async saveChanges() {
      this.isProcessing = true;

      this.models.iraa_road_id = this.roads
        .find((road) => road.id == this.models.pavement_road)
        .id.toString();
      this.models.iraa_road_name = this.roads.find(
        (road) => road.id == this.models.pavement_road
      ).attributes.name;
      delete this.models.pavement_road;
      console.log(this.models);

      API.post(`pavement-cases`, this.models)
        .then(() => {
          this.isProcessing = false;

          Swal.fire("Tampalan case added", "", "success").then(() => {
            this.closeModal();
          });
        })
        .catch((err) => {
          this.isProcessing = false;

          console.error(err);
        });
    },
  },
};
</script>